import "@/components/shared/styles/main.scss";
import SEO from "@/components/shared/components/molecules/SEO";
import CookieConsentComponent from "@/components/shared/components/atoms/CookieConsentComponent";
import Analytics from "@/components/shared/components/molecules/Analytics";
import Footer from "@/components/shared/components/organisms/Footer";
import Menu from "@/components/shared/components/organisms/Menu/Menu";
import AppDrawers from "@/components/shared/components/organisms/AppDrawers";
import Favicon from "@/components/shared/components/atoms/Favicon";
import ChooseLocationWidget from "@/components/shared/components/atoms/ChooseLocationWidget";
import ScrollManager from "@/components/shared/components/atoms/ScrollManager";
import { useRouter } from "next/router";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export default function App({ Component, pageProps }) {
  const router = useRouter();
  return (
    <>
      <style>{`
            .grecaptcha-badge {
                visibility: hidden;
            }
        `}</style>
      <GoogleReCaptchaProvider
        reCaptchaKey={process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY}
      >
        <Favicon websiteType={pageProps.websiteType} />
        <SEO
          title={pageProps?.SEO?.meta_title || pageProps.title}
          description={pageProps?.SEO?.meta_description || null}
          ogImage={
            pageProps?.SEO?.og_image?.data
              ? pageProps?.SEO.og_image.data.attributes.url
              : null
          }
          websiteType={pageProps.websiteType}
          alternates={pageProps.alternates}
        />
        {pageProps.GOOGLE_ANALYTICS && (
          <Analytics trackingCode={pageProps.GOOGLE_ANALYTICS} />
        )}
        <ScrollManager />
        <Menu
          other_languages={pageProps.other_languages}
          global_link={pageProps.global_website}
          languages={pageProps.languages}
          menuInfo={pageProps.navbar}
          selectedLanguage={pageProps.locale}
          regions={pageProps.regions}
          top_bar_items={pageProps.navbar?.data?.attributes?.top_bar}
          websiteType={pageProps.websiteType}
          websiteTitle={pageProps.websiteTitle}
          translations={pageProps.translations}
        />
        <main>
          <Component {...pageProps} />
        </main>
        <Footer
          info={pageProps.footer}
          websiteType={pageProps.websiteType}
          translations={pageProps.translations}
        />
        <AppDrawers pageProps={pageProps} />
        <ChooseLocationWidget />
        <CookieConsentComponent locale={pageProps.locale} />
      </GoogleReCaptchaProvider>
    </>
  );
}
